<template>
  <span>
    <b-button
      id="notifications-icon"
      class="p-1 m-0 border-0 notifications-icon"
      variant="link"
    >
      <font-awesome-icon
        ref="notificationsBell"
        variant="info"
        title="Notifications"
        :icon="['fa', 'bell']"
        size="lg"
        class="notifications-icon"
      />
    </b-button>
    <b-popover
      target="notifications-icon"
      triggers="click blur"
      :show.sync="showPopover"
      placement="bottom"
      variant="info"
      @hidden="onClose"
    >
      <p class="m-0">{{ getRssFeedsMesage(numRssUpdates) }}</p>
      <p class="m-0">{{ getDbStatsMesage(numDocuments) }}</p>
      <a href="/#/notifications">Click here for the notification list</a>
    </b-popover>
  </span>
</template>

<script>
import {
  addToLocalStorage,
  getFromLocalStorage,
} from '../utils/localStorageUtils';
import { NOTIFICATION_SHOWN_KEY } from '../constants/fromLocalStorageConstants';
import { getAWSDateTime } from '../utils/dateUtils';
import { DAY_MS } from '../constants/constants';
import ESService from '@/services/ESService';

export default {
  name: 'NotificationsPopover',
  data() {
    return {
      showPopover: false,
      numDocuments: 0,
      numRssUpdates: 0,
    };
  },
  created() {
    this.numDays = 1;
    this.getDbStatsMesage = (numDocuments) =>
      numDocuments
        ? `${numDocuments} database updates in the past day`
        : `No new database updates in the past day`;
    this.getRssFeedsMesage = (numUpdates) =>
      numUpdates
        ? `${numUpdates} RSS feed updates in the past day`
        : `No new RSS feed updates in the past day.`;
  },
  mounted() {
    Promise.all([
      ESService.getDatabaseStats({
        dateSince: getAWSDateTime(
          true,
          Date.now() - this.numDays * DAY_MS
        ).split('T')[0],
        includeDocs: false,
      }),
      ESService.getRssFeeds({
        dateTimeSince: getAWSDateTime(
          false,
          Date.now() - this.numDays * DAY_MS
        ).split('Z')[0],
        includeFeeds: false,
      }),
    ]).then(([dbStatsRes, rssFeedsRes]) => {
      const numDocuments = dbStatsRes.data.num_documents;
      const numRssUpdates = rssFeedsRes.data.num_feeds;
      this.numDocuments = numDocuments;
      this.numRssUpdates = numRssUpdates;

      if (
        (numDocuments || numRssUpdates) &&
        !getFromLocalStorage(NOTIFICATION_SHOWN_KEY)
      ) {
        this.showPopover = true;
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$refs.notificationsBell.focus();
          });
        });
        setTimeout(() => (this.showPopover = false), 5000);
        addToLocalStorage(NOTIFICATION_SHOWN_KEY, true);
      }
    });
  },
  methods: {
    onClose() {
      this.showPopover = false;
    },
  },
};
</script>

<style scoped></style>
